import React from 'react'

export function FormFieldRow({ children }: { children: React.ReactNode }) {
  return <div className='l-form-field-row'>{children}</div>
}
